<template>
    <div>
        <el-form :inline="true" :model="systemOrderForm">
            <el-form-item label="状态：">
                <el-select>
                    <el-option>全部</el-option>
                    <el-option>待处理</el-option>
                    <el-option>已处理</el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="问题类型：">
                <el-select>
                    <el-option>全部</el-option>
                    <el-option>退款</el-option>
                    <el-option>使用</el-option>
                    <el-option>转卡</el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="工单号：">
                <el-input></el-input>
            </el-form-item>
            <el-form-item label="ICCID号：">
                <el-input></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary">搜索查询</el-button>
                <el-button type="primary">添加</el-button>
            </el-form-item>
        </el-form>

        <el-table :data="tableData" @selection-change="handleSelectionChange">
            <el-table-column type="index" label="序号"></el-table-column>      
            <el-table-column prop="3" label="工单ID"></el-table-column>
            <el-table-column prop="3" label="提交人"></el-table-column>
            <el-table-column prop="4" label="问题描述"></el-table-column>
            <el-table-column prop="5" label="提交时间"></el-table-column>
            <el-table-column prop="6" label="处理时间"></el-table-column>
            <el-table-column prop="6" label="来源"></el-table-column>
            <el-table-column prop="6" label="处理状态"></el-table-column>            
            <el-table-column prop="6" label="问题状态"></el-table-column>            
            <el-table-column prop="6" label="操作"></el-table-column>
        </el-table>
        
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[100, 200, 300, 400]"
            :page-size="100"
            layout="total, sizes, prev, pager, next, jumper"
            :total="400">
        </el-pagination>        
    </div>
</template>
<script>
export default {
    data(){
        return {
            systemOrderForm: {
                date: '',
                agentName: ''
            },
            tableData: [
                {
                    2: '123123',
                    3: 'aaaaaaa',
                    4: 'ooooooo'
                },
                {
                    2: 'q123123',
                    3: 'qaaaaaaa',
                    4: 'qooooooo'
                }
            ],
            multipleSelection: []
        }
    },
    methods: {
        handleSelectionChange(val){
            this.multipleSelection = val;
        }
    }
}
</script>
<style lang="less" scoped>

</style>

